module.exports = __webpack_public_path__ + "img/3.c2705c5e.png";